import * as React from 'react'

import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import DayCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/DayCell'
import type {
  Column,
  ColumnsType,
} from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

interface Props {
  shiftsRow: ShiftsRow
  columns: ColumnsType
  contractVersions: ContractVersions
}

const BasicRow = ({ shiftsRow, columns, contractVersions }: Props) => {
  return (
    <>
      {columns.map((column: Column) => {
        return (
          <WrapperCell
            key={`DayCell-${shiftsRow.key}-${column.formattedDate}`}
            minWidth={column.minWidth}
          >
            <DayCell date={column.date} shiftsRow={shiftsRow} contractVersions={contractVersions} />
          </WrapperCell>
        )
      })}
    </>
  )
}

export default observer(BasicRow)
